import { Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "@changey/react-leaflet-markercluster";
import L from "leaflet";
import MapApiPinpoint from "./MapApiPinpoint";

const MapClusterGroup = ({ plantations, isClusteringEnabled }) => {
  const createCustomIcon = (category) => {
    const iconUrl =
      category === "DEPARTMENTAL"
        ? process.env.PUBLIC_URL + "/assets/images/pinplantyellow.png"
        : process.env.PUBLIC_URL + "/assets/images/pinplant.png";

    return L.icon({
      iconUrl,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });
  };

  if (!isClusteringEnabled) {
    // render markers without clustering
    return plantations.map((plantation, index) => {
      if (
        !plantation.location?.coordinates ||
        plantation.location.coordinates.length !== 2
      )
        return null;

      const [lng, lat] = plantation.location.coordinates;
      if (typeof lat !== "number" || typeof lng !== "number") return null;

      return (
        <Marker
          key={plantation.plantationKey || index}
          position={[lat, lng]}
          icon={createCustomIcon(plantation.category)}
        >
          <Popup>
            <MapApiPinpoint plantation={plantation} index={index} />
          </Popup>
        </Marker>
      );
    });
  }

  // clustering enabled
  return (
    <MarkerClusterGroup
      chunkedLoading
      maxClusterRadius={50}
      spiderfyOnMaxZoom
      showCoverageOnHover
      zoomToBoundsOnClick
    >
      {plantations.map((plantation, index) => {
        if (
          !plantation.location?.coordinates ||
          plantation.location.coordinates.length !== 2
        )
          return null;

        const [lng, lat] = plantation.location.coordinates;
        if (typeof lat !== "number" || typeof lng !== "number") return null;

        return (
          <MapApiPinpoint plantation={plantation} index={index} />

        );
      })}
    </MarkerClusterGroup>
  );
};

export default MapClusterGroup;
